import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { useSiteMetadata } from '../utils';

const SEO = ({ selectedLocale, location, specifics }) => {
  const [data] = useSiteMetadata(selectedLocale);

  const title = `${data.node.data.meta_title}${
    specifics.title ? ` - ${specifics.title}` : ''
  }`;
  const description = specifics.description || data.node.data.meta_description;
  const image = specifics.image || data.node.data.share_image.url;
  const url = `${process.env.GATSBY_SITE_URL}${location.pathname}/`;

  return (
    <Helmet>
      <html lang={selectedLocale.split('-')[0]} />
      <link rel="canonical" href={url} />

      <title>{title}</title>
      <meta name="description" content={description} />

      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={selectedLocale} />
      <meta property="og:title" content={title} />
      <meta property="og:site_name" content={data.node.data.meta_title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={data.node.data.meta_title} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="keywords" content="" />
    </Helmet>
  );
};

SEO.defaultProps = {
  location: {
    pathname: '',
  },
  specifics: {
    title: '',
    description: '',
    image: '',
  },
};

SEO.propTypes = {
  selectedLocale: PropTypes.string.isRequired,
  location: PropTypes.shape({ pathname: PropTypes.string }),
  specifics: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
  }),
};

export default SEO;
